// @flow
import React from 'react';
import haWrapper from '../../utils/haWrapper';
import {sendCustomAnalytics} from '../../utils/loadTimeAnalyticsWrapper';

import type {ComponentType} from 'react';

const MEASURE_NAME = 'primary.action.rendered';

export default function withPAR<Props: {}>(
    WrappedComponent: ComponentType<Props>
) {
    let namedWrappedComponent = class extends React.Component<Props> {
        componentDidMount() {
            const {userTiming} = haWrapper;
            const alreadyMeasured =
                userTiming.getEntriesByName(MEASURE_NAME, 'mark').length > 0;

            if (!alreadyMeasured) {
                userTiming.mark(MEASURE_NAME);
                sendCustomAnalytics(MEASURE_NAME, 'mark', (analytics) => ({
                    primaryActionRendered: {
                        duration: Math.ceil(analytics.startTime),
                        referrer: document.referrer
                    }
                }));
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    /* istanbul ignore next */
    namedWrappedComponent.displayName = `withPAR(${WrappedComponent.displayName ||
        WrappedComponent.name ||
        'Component'})`;
    return namedWrappedComponent;
}
